/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Dialog_Confirm_Reject_BtnInputs */

const vi_sl_detail_dialog_confirm_reject_btn = /** @type {(inputs: Sl_Detail_Dialog_Confirm_Reject_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận từ chối`)
};

/**

* @param {Sl_Detail_Dialog_Confirm_Reject_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_dialog_confirm_reject_btn = /** @type {((inputs?: Sl_Detail_Dialog_Confirm_Reject_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Dialog_Confirm_Reject_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_dialog_confirm_reject_btn(inputs)
});